interface NotesTextareaProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  containerClassName?: string;
  textareaClassName?: string;
}

export function NotesTextarea({
  value,
  onChange,
  placeholder,
  containerClassName = "min-h-[280px]",
  textareaClassName = "min-h-[250px] resize-y",
}: NotesTextareaProps) {
  return (
    <div className={`rounded-[28px] bg-[#EDEDED] p-3 ${containerClassName}`}>
      <div className="h-full rounded-[24px] bg-[#F8F8F8] shadow-[inset_0_1px_2px_rgba(0,0,0,0.04)]">
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className={`scrollbar-hidden w-full overflow-y-auto bg-transparent p-6 text-[15px] leading-[1.6] text-[#1d1d1f] outline-none placeholder:text-gray-300 ${textareaClassName}`}
        />
      </div>
    </div>
  );
}
